module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination-wrapper",
    attrs: {
      "id": "pagination"
    }
  }, [(_vm.totalElements > 10) ? _c('ul', {
    staticClass: "pagination-btn-group"
  }, [(_vm.currentPage > 1) ? _c('button', {
    staticClass: "pagination-btn before",
    on: {
      "click": function($event) {
        return _vm.goPrev()
      }
    }
  }, [_vm._v("<")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.pageRange(_vm.startPage, _vm.endPage)), function(pageNumber) {
    return _c('button', {
      staticClass: "pagination-btn",
      class: {
        active: _vm.currentPage === pageNumber
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.transParentPage(pageNumber)
        }
      }
    }, [_vm._v("\n      " + _vm._s(pageNumber) + "\n    ")])
  }), _vm._v(" "), (_vm.currentPage !== _vm.lastPage) ? _c('button', {
    staticClass: "pagination-btn next",
    on: {
      "click": function($event) {
        return _vm.goNext()
      }
    }
  }, [_vm._v(">")]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0123d461"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/shared/VuePagination.vue
// module id = 1267
// module chunks = 6